import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import FeedbackForm from "./FeedbackForm";

type Props = {
  closeModalOffCanvas: () => void;
  showModalOffcanvas: boolean;
  isAdd?: boolean;
  content?: string;
  onSubmit: (data: any) => void;
  isLoading?: boolean;
  subject?: string;
};

function FeedbackModal({
  closeModalOffCanvas,
  showModalOffcanvas,
  content,
  subject,
  onSubmit,
}: Props) {
  return (
    <MolhamModalOffcanvas
      onHide={closeModalOffCanvas}
      show={showModalOffcanvas}
    >
      <FeedbackForm
        close={closeModalOffCanvas}
        content={content}
        subject={subject}
        onSubmit={onSubmit}
        textLength={999}
      />
    </MolhamModalOffcanvas>
  );
}

export default FeedbackModal;
